import { Menu, MenuItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import QrCodeIcon from '@mui/icons-material/QrCode';
import DownloadIcon from '@mui/icons-material/Download';
import { useHatm } from '../../context/HatmContext';
import { generateShareUrl } from '../../utils/helpers';
import { exportToCsv } from '../../utils/export';

export default function ShareButton({ hatmId }) {
  const { 
    shareAnchorEl, 
    setShareAnchorEl, 
    setSuccessAlert,
    setQrDialogOpen,
    state 
  } = useHatm();

  const handleShareClick = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setShareAnchorEl(null);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(generateShareUrl(hatmId));
    setSuccessAlert(true);
    setTimeout(() => setSuccessAlert(false), 3000);
    handleClose();
  };

  const handleWhatsAppShare = () => {
    const shareText = "Beraber hatim okuyalım mı?";
    const shareUrl = generateShareUrl(hatmId);
    window.open(
      `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`,
      "_blank"
    );
    handleClose();
  };

  return (
    <>
      <Typography
        component="span"
        onClick={handleShareClick}
        sx={{
          color: '#EDAFB8',
          cursor: 'pointer',
          mx: 1,
          display: 'inline',
          '&:hover': {
            color: '#e39aa5',
            textDecoration: 'underline'
          }
        }}
      >
        paylaşabilirsin
      </Typography>

      <Menu
        anchorEl={shareAnchorEl}
        open={Boolean(shareAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleCopyLink}>
          <ListItemIcon>
            <LinkIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Bağlantıyı Kopyala</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={handleWhatsAppShare}>
          <ListItemIcon>
            <WhatsAppIcon fontSize="small" sx={{ color: "#25D366" }} />
          </ListItemIcon>
          <ListItemText>WhatsApp ile Paylaş</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => {
          setQrDialogOpen(true);
          handleClose();
        }}>
          <ListItemIcon>
            <QrCodeIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>QR Kod</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => {
          exportToCsv(state, hatmId);
          handleClose();
        }}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>CSV olarak indir</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
} 